import { cn } from '../../lib/cn';
import type { CrisisEventRow } from '../../mobilecompanion/framework';

type Props = { events?: CrisisEventRow[] };

export function CrisisCenterPanel({ events = [] }: Props) {
  return (
    <div className="space-y-2">
      {events.map((e) => (
        <div key={e.title} className="flex items-start justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="min-w-0 flex-1">
            <p className="text-sm font-medium">{e.title}</p>
            <p className="mt-0.5 text-xs text-slate-500">{e.type}</p>
          </div>
          <div className="shrink-0 text-right">
            <span className={cn(
              'rounded-full px-2 py-0.5 text-xs font-medium',
              e.severity === 'critical' ? 'bg-error-50 text-error-700 dark:bg-error-950 dark:text-error-300' :
              e.severity === 'high' ? 'bg-warning-50 text-warning-700 dark:bg-warning-950 dark:text-warning-300' :
              'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
            )}>
              {e.severity}
            </span>
            <p className="mt-1 text-xs text-slate-500">{e.status}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
